import { AlignLeft } from 'lucide-react';
import type { Source } from '@/data/fixtures';
import { useSourceText } from '@/components/features/learning/sources/useSourceText';
import {
  ViewerLoading,
  ViewerError,
} from '@/components/features/learning/sources/viewers/shell/ViewerStates';
import { ViewerShell } from '@/components/features/learning/sources/viewers/shell/ViewerShell';

interface PlainTextViewerProps {
  source: Source;
}

/**
 * Renders any text-ish format we don't have a richer viewer for -
 * `.txt`, `.json`, `.yaml`, `.log`, `.rst`, etc. Displayed in a
 * monospace pre block with whitespace preserved.
 */
export function PlainTextViewer({ source }: PlainTextViewerProps) {
  const { text, isLoading, error } = useSourceText(source.id);

  if (isLoading) return <ViewerLoading />;
  if (error)
    return <ViewerError message="Couldn't load file" detail={error.message} />;

  return (
    <ViewerShell
      sourceId={source.id}
      icon={AlignLeft}
      label='Text'
      tone='reference'
    >
      <pre className='h-full w-full overflow-auto whitespace-pre-wrap break-words p-5 font-code text-[13px] leading-relaxed text-foreground'>
        {text || ''}
      </pre>
    </ViewerShell>
  );
}
